import {useTranslation} from "react-i18next";
import React from "react";
import Button from "..//Button";
import Text from "../Text";
import {useGlobalContext} from "../../contexts/globalContext";

const ConfirmModal: React.FC<{text: string, onSubmit: () => void}> = ({text, onSubmit}) => {
    const { t } = useTranslation(['common'])
    const { closeModal } = useGlobalContext()

    return (
        <div className={'d-flex align-items-center justify-content-between flex-column'} style={{width: '350px'}}>
            <Text>
                {text}
            </Text>
            <Button
                hierarchy={'primary'}
                text={t('confirm')}
                fn={() => onSubmit()}
                classes={'w-100 mx-4 my-2'}
            />
            <Button
                hierarchy={'secondary'}
                text={t('abort')}
                fn={() => closeModal()}
                classes={'w-100 mx-4 my-2'}
            />
        </div>
    )
}

export default ConfirmModal
